/* ============
 * The initial state of the patient module.
 * ============
 */
export default {
  loading: false,
  patients: [],
  patient: {
    user: {}
  },
  error: null,
  totalCount: 0,
  isPatientsloading: false,
  currentPatient: {},
  patientDataToMsg : {
    mrId : '',
    isSelectedPatient : false
  }
};
